// Reminders report hook — fetches GET /api/v1/reports/reminders for a
// given date. Powers the Automated Reminders tab.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';

export interface ReminderRow {
  booking_ref: string;
  customer_name: string;
  customer_phone: string;
  customer_email: string;
  car_make_model: string;
  car_registration: string;
  booking_date: string;
  timeframe: string;
  driver_name: string | null;
  email_reminder_sent: boolean;
  email_reminder_sent_at: string | null;
  sms_reminder_sent: boolean;
  sms_reminder_sent_at: string | null;
  booking_status: string;
}

export interface RemindersTotals {
  all_time_email: number;
  all_time_sms: number;
  queue_pending: number;
  queue_sent: number;
  queue_failed: number;
}

export interface RemindersBreakdown {
  email_only: number;
  sms_only: number;
  both: number;
  status_completed: number;
  status_pending: number;
  status_cancelled: number;
}

export interface RemindersReport {
  date: string;
  available_dates: string[];
  totals: RemindersTotals;
  breakdown: RemindersBreakdown;
  rows: ReminderRow[];
}

export function useRemindersReport(date: string) {
  return useQuery<RemindersReport>({
    queryKey: queryKeys.reports.reminders(date),
    queryFn: async () => {
      const res = await apiClient.get<RemindersReport>(
        `${endpoints.reports.reminders}?date=${encodeURIComponent(date)}`,
      );
      return res.data;
    },
    staleTime: 60_000,
  });
}
